/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkPackage
 */
export interface WorkPackage {
    /**
     * 
     * @type {string}
     * @memberof WorkPackage
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkPackage
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof WorkPackage
     */
    code: string | null;
}

/**
 * Check if a given object implements the WorkPackage interface.
 */
export function instanceOfWorkPackage(value: object): value is WorkPackage {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    return true;
}

export function WorkPackageFromJSON(json: any): WorkPackage {
    return WorkPackageFromJSONTyped(json, false);
}

export function WorkPackageFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkPackage {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'code': json['code'],
    };
}

export function WorkPackageToJSON(value?: WorkPackage | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'code': value['code'],
    };
}

